// src/components/common/EmployeeInfo.js
import React from "react";
// If you already use MUI's Person icon, keep this:
import PersonIcon from "@mui/icons-material/Person";
import { stringToRGB } from "../../../../utils";
// If you use a different icon system, swap the import above.

const EmployeeInfo = ({
  landmarkEmployee,
  handleOnClick = () => {},
  disableHover = false,
  showLogout = false,
  logout = () => {},
  avatarColor, // optional override for the avatar background
}) => {
  if (!landmarkEmployee) return null;

  const { firstName, lastName, email, employeeId } = landmarkEmployee;
  const disableHoverClass = disableHover ? "disable-hover" : "";

  return (
    <div className="account-row">
      <div
        className={`account ${disableHoverClass}`}
        onClick={() => handleOnClick(landmarkEmployee)}
      >
        <div
          className="user-icon"
          style={{ backgroundColor: avatarColor || stringToRGB(employeeId) }}
        >
          <PersonIcon className="icon" />
        </div>
        <div>
          <div className="name">
            {firstName} {lastName}
          </div>
          <div className="email">{email}</div>
        </div>
      </div>

      {showLogout && (
        <div
          className="logout-link"
          onClick={(e) => {
            e.stopPropagation(); // don't trigger the account click
            logout();
          }}
          title="Log out"
        >
          Log out
        </div>
      )}
    </div>
  );
};

export default React.memo(EmployeeInfo);
